import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreRoutingModule } from './core-routing.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { ConfirmboxComponent } from './confirmbox/confirmbox.component';
import { ErrorComponent } from './error/error.component';
import { PdfValidator } from './validations/pdf-validator';
import { XLSValidator } from './validations/xls-validator';
import { LoaderComponent } from './loader/loader.component';
import { PatternRestrictDirective } from './validations/pattern-restrict.directive';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ChangePasswordComponent } from '../login/change-password/change-password.component';
import { ConfigService } from './services/config.service';
import { ErrorHandlerService } from './services/error-handler.service';
import { PaginationComponent } from './pagination/pagination.component';

import { HttpClientModule } from '@angular/common/http';
import { SpaceValidator } from './validations/space-validator';
import { TaskComponent } from './task/task.component';
@NgModule({
    declarations: [
        ConfirmboxComponent, ErrorComponent,
        LoaderComponent,
        PdfValidator,
        XLSValidator, PaginationComponent,
        PatternRestrictDirective, SpaceValidator, TaskComponent
    ],
    imports: [
        CommonModule,
        CoreRoutingModule,
        FormsModule,
        ReactiveFormsModule,
         HttpClientModule
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports: [
        ConfirmboxComponent,
        LoaderComponent,
        PdfValidator,
        XLSValidator,
        PatternRestrictDirective,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PaginationComponent,
 HttpClientModule, SpaceValidator
    ],
    providers: [ConfigService, ErrorHandlerService]
})
export class CoreModule{ }
